/*  ========================================================================
    # Scripts - Accordion
    ========================================================================  */

const Accordion = {
  cfg: {
    accordionEntries: document.querySelectorAll('.s-accordion__entry')
  },

  /**
   * Handler.
   */
  handler() {
    this.cfg.accordionEntries.forEach(entry => {
      entry.querySelector('.s-accordion__entry-header').addEventListener('click', () => {
        const isOpen =
          entry.querySelector('.s-accordion__entry-header').getAttribute('aria-expanded') ===
          'true';
        if (isOpen) {
          // Collapse
          entry.removeAttribute('data-open');
          entry.querySelector('.s-accordion__entry-header').setAttribute('aria-expanded', 'false');
          entry
            .querySelector('.s-accordion__entry-content-wrapper')
            .setAttribute('aria-hidden', 'true');
          entry.querySelector('.s-accordion__entry-content-wrapper').setAttribute('inert', '');
        } else {
          // Collapse
          entry.setAttribute('data-open', '');
          entry.querySelector('.s-accordion__entry-header').setAttribute('aria-expanded', 'true');
          entry
            .querySelector('.s-accordion__entry-content-wrapper')
            .setAttribute('aria-hidden', 'false');
          entry.querySelector('.s-accordion__entry-content-wrapper').removeAttribute('inert');
        }
      });
    });
  },

  /**
   * Initialize.
   */
  init() {
    if (this.cfg.accordionEntries.length > 0) this.handler();
  }
};

export default Accordion;
